(function () {
  const PX_PER_SECOND = 42;
  const MIN_DURATION = 8;
  const MAX_DURATION = 28;
  const STATIC_BUFFER = 12;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getPrimarySegment(track) {
    const segment = track.querySelector(
      '.announcement-bar__marquee-segment:not(.announcement-bar__marquee-segment--clone)'
    );
    if (!segment) return null;
    return segment.querySelector('.announcement-bar__marquee-content') || segment;
  }

  function setStatic(root, track, isStatic) {
    root.classList.toggle('announcement-bar__marquee--static', isStatic);
    track.style.transform = '';
    if (isStatic) {
      track.style.removeProperty('--announcement-marquee-duration');
    }
  }

  function initMarquee(root) {
    const track = root.querySelector('.announcement-bar__marquee-track');
    if (!track) return;

    const segment = getPrimarySegment(track);
    const containerWidth = root.clientWidth;

    if (!segment || !containerWidth) {
      setStatic(root, track, true);
      return;
    }

    if (prefersReducedMotion()) {
      setStatic(root, track, true);
      return;
    }

    const contentWidth = segment.scrollWidth;

    if (!contentWidth || contentWidth <= containerWidth + STATIC_BUFFER) {
      setStatic(root, track, true);
      return;
    }

    setStatic(root, track, false);
    const duration = Math.max(MIN_DURATION, Math.min(MAX_DURATION, contentWidth / PX_PER_SECOND));
    track.style.setProperty('--announcement-marquee-duration', duration + 's');
  }

  function observeMarquee(root) {
    if (root._announcementMarqueeObserved) return;
    root._announcementMarqueeObserved = true;

    if (typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(function () {
      initMarquee(root);
    });
    observer.observe(root);
    root._announcementMarqueeResizeObserver = observer;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-announcement-marquee]').forEach(function (root) {
      initMarquee(root);
      observeMarquee(root);
    });
  }

  function bind() {
    initAll(document);

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initAll(document);
      }, 150);
    });

    document.querySelectorAll('slideshow-component.announcement-bar').forEach(function (el) {
      el.addEventListener('slideChanged', function () {
        requestAnimationFrame(function () {
          initAll(el);
          requestAnimationFrame(function () {
            initAll(el);
          });
        });
      });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        initAll(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
